/*
 * @Author: 晋枫
 * @Date: 2021-09-07 13:50:10
 * @LastEditTime: 2021-09-13 19:36:43
 * @LastEditors: 晋枫
 * @Description:
 * @FilePath: /jmj-7v1-task/src/router/modules/bulletinBoard/organizationalCapability.js
 * 🍁YOU CAN（NOT）REDO🍁
 */
const organizationalCapabilityRouter = [
  {
    path: 'organizational-capability-board',
    name: 'OrganizationalCapabilityBoard',
    component: () => import('@/views/wxapp/bulletin-board/profit-board-content/org-capability/index.vue'),
    meta: {
      title: '组织能力表达率'
    }
  },
  {
    path: 'department-mature-saturation',
    name: 'DepartmentMatureSaturation',
    component: () => import('@/views/wxapp/bulletin-board/profit-board-content/org-capability/department/MatureSaturation/index.vue'),
    meta: {
      title: '成熟人员饱和率'
    }
  },
  {
    path: 'department-leader-competent',
    name: 'DepartmentLeaderCompetent',
    component: () => import('@/views/wxapp/bulletin-board/profit-board-content/org-capability/department/LeaderCompetent/index.vue'),
    meta: {
      title: '干部胜达标率'
    }
  },
  {
    path: 'department-human-effect',
    name: 'DepartmentHumanEffect',
    component: () => import('@/views/wxapp/bulletin-board/profit-board-content/org-capability/department/HumanEffect/index.vue'),
    meta: {
      title: '绩效达标率'
    }
  },
  {
    path: 'department-invite-list',
    name: 'DepartmentInviteList',
    component: () => import('@/views/wxapp/bulletin-board/profit-board-content/org-capability/department/InviteList/index.vue'),
    meta: {
      title: '需招聘人数'
    }
  },
  {
    path: 'department-leader-replace',
    name: 'DepartmentLeaderReplace',
    component: () => import('@/views/wxapp/bulletin-board/profit-board-content/org-capability/department/LeaderReplace/index.vue'),
    meta: {
      title: '干部替手'
    }
  },
  {
    path: 'store-mature-saturation',
    name: 'StoreMatureSaturation',
    component: () => import('@/views/wxapp/bulletin-board/profit-board-content/org-capability/store/MatureSaturation/index.vue'),
    meta: {
      title: '成熟人员饱和率'
    }
  },
  {
    path: 'store-leader-competent',
    name: 'StoreLeaderCompetent',
    component: () => import('@/views/wxapp/bulletin-board/profit-board-content/org-capability/store/LeaderCompetent/index.vue'),
    meta: {
      title: '干部胜达标率'
    }
  },
  {
    path: 'store-human-effect',
    name: 'StoreHumanEffect',
    component: () => import('@/views/wxapp/bulletin-board/profit-board-content/org-capability/store/HumanEffect/index.vue'),
    meta: {
      title: '绩效达标率'
    }
  },
  {
    path: 'store-income-reach',
    name: 'StoreIncomeReach',
    component: () => import('@/views/wxapp/bulletin-board/profit-board-content/org-capability/store/IncomeReach/index.vue'),
    meta: {
      title: '收入达标人员'
    }
  }
]
export default organizationalCapabilityRouter
